export default __webpack_public_path__ + "static/media/atlas_logo.a35be865.svg";